import React, { useState, useEffect } from 'react';
import { Select, MenuItem, Typography, Box, FormControl } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { resolveFieldsService } from '../../apis/EntitiesSelection';
// import { fetchResolvedFields } from '../../state/slices/mappingSlice';

function RelationFunc({
  selectedFields,
  workflowId,
  updatedConfig,
  sourceField,
  setSourceField,
  sourceEntity,
  setSourceEntity,
  selectedEntities,
  relationEntity,
  setRelationEntity,
  relationField,
  setRelationField,
  relationValue,
  setRelationValue,
  relationFields,
  setRelationFields,
  sourceFieldRelation,
  setSourceFieldRelation,
  selectedFieldName,
  setSelectedFieldName,
}) {
  const [sourceRelationFields, setSourceRelationFields] = useState([]);
  const destinationNode = updatedConfig?.nodes?.find(
    (node) => node?.config?.type === 'destinationNode'
  );

  useEffect(() => {
    if (selectedFields?.length > 0 && !sourceField) {
      setSourceField(selectedFields[0]); // ✅ it's a string now
    }
    if (selectedEntities?.length > 0 && !sourceEntity) {
      setSourceEntity(selectedEntities[0]); // ✅ it's a string now
    }
  }, [selectedFields, selectedEntities, sourceField, sourceEntity]);

  const destinationKey = `${destinationNode.id}-${
    destinationNode?.config?.connection?.conn_id || ''
  }-${destinationNode?.config?.module || ''}`;
  const entitiesByWorkflow = useSelector(
    (state) => state.entities.entitiesByWorkflow
  );
  const finalConfigPayload = useSelector(
    (state) => state.mapping.finalConfigPayloadByWorkflow?.[workflowId]
  );
 
  const destEntityList =
    entitiesByWorkflow?.[workflowId]?.[destinationKey] || [];

  const resolvedData = useSelector(
    (state) => state.mapping.resolvedFieldsByWorkflow?.[workflowId]
  );

  const renderBy = (options) => (val) => {
    if (!val) return '';
    const hit = options.find((o) => o.value === val);
    return hit ? hit.label : String(val);
  };

  const uniqByValue = (arr) => {
    const map = new Map();
    arr.forEach((o) => {
      if (o?.value) map.set(o.value, o);
    });
    return [...map.values()];
  };

  const relationEntityOptions = (destEntityList || []).map((e) => ({
  value: e.entity_name, // backend ID
  label: e.label || e.entity_name, // UI label fallback
}));

  const MENU_PROPS = {
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
    marginThreshold: 0,
    PaperProps: {
      sx: {
        maxHeight: 240,
        mt: 0.5,
        minWidth: 0,
        width: '200px',
      },
    },

    MenuListProps: {
      dense: true,
      sx: { py: 0 },
    },
  };

  const StyledSelect = styled(Select)({
    width: '100%',
    fontSize: '0.938rem',
    borderRadius: '4px',
    '& .MuiOutlinedInput-root': {
      height: '40px', // Set fixed height
      borderRadius: '4px',
      paddingRight: '32px', // Ensure space for dropdown icon
    },
    '& .MuiSelect-select': {
      padding: '7px 12px',
      display: 'flex',
      alignItems: 'center',
      fontSize: '0.938rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.5)',
    },
  });

useEffect(() => {
  if (!selectedEntities?.length || !resolvedData?.length) {
    setSourceRelationFields([]);
    setSelectedFieldName([]);
    return;
  }

  const entityNamesLower = selectedEntities
    .map((ent) =>
      (typeof ent === 'string' ? ent : ent?.entity_name)?.toLowerCase()
    )
    .filter(Boolean);

  const allFieldOptions = resolvedData
    .filter(
      (node) =>
        (node.type === 'source' || node.type === 'sourceNode') &&
        entityNamesLower.includes(node?.fields?.entity_name?.toLowerCase())
    )
    .flatMap((node) => node?.fields?.fields || [])
    .map((f) => ({
      value: f.field_name || f.field_label,  // backend id
      label: f.field_label || f.field_name,  // ui label
    }))
    .filter((o) => typeof o.value === 'string' && typeof o.label === 'string');

  const selectedFieldSet = new Set(
    (selectedFields || []).map((s) => s?.toLowerCase()).filter(Boolean)
  );

  const selectedFieldNames = allFieldOptions
    .filter((o) => selectedFieldSet.has(o.label.toLowerCase()))
    .map((o) => o.value);

  setSelectedFieldName(selectedFieldNames);
  setSourceRelationFields(uniqByValue(allFieldOptions)); // ✅ no extra exclusions
}, [selectedEntities, resolvedData, selectedFields]);


  console.log('selectedFieldName:', selectedFieldName);

  const handleRelationFieldChange = (e) => {
    setRelationField(e.target.value);
  };
  const handleRelationEntityChange = async (e = null) => {
    const selected = e ? e.target.value : relationEntity; // Use the event value or the current relationEntity value // const selected = e.target.value; // entity_name
    setRelationEntity(selected);
    setRelationField('');

    const enrichedPayload = Object.values(finalConfigPayload)
      .filter((n) => n.type === 'destination' || n.type === 'destinationNode')
      .map((n) => ({
        ...n,
        selectedEntities: [{ entity_name: selected, label: selected }],
      }));

    if (selected && enrichedPayload.length) {
      try {
        const response = await resolveFieldsService({
          label: 'FieldResolution',
          configs: enrichedPayload,
        });

        const fieldOptions = Array.isArray(response)
          ? (response[0]?.fields?.fields || [])
              .map((f) => ({
                value: f.field_name || f.field_label, // backend ID
                label: f.field_label || f.field_name, // UI label
              }))
              .filter((o) => typeof o.value === 'string')
          : [];

        setRelationFields(fieldOptions);
        // if (fieldOptions.length) setRelationField(fieldOptions[0].value);
        if (!relationField && fieldOptions.length) {
          setRelationField(fieldOptions[0].value);
        } else if (
          relationField &&
          fieldOptions.some((option) => option.value === relationField)
        ) {
          // If referenceField already has a value that exists in fieldOptions, retain it
          // Otherwise, set it to the first field option
          setRelationField(relationField);
        } // Set the first field as the default
      } catch {
        setRelationFields([]);
      }
    } else {
      setRelationFields([]);
    }
  };

  useEffect(() => {
    if (relationEntity) {
      handleRelationEntityChange(); // Call the function even when referenceEntity has a value
    }
  }, [relationEntity]);

  return (
    <>
      <Box mt={1}>
        {/* Source Relation Field */}
        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Source Relation Field
          </Typography>
          {/* Source Relation Field (value = field_name, show label) */}
          <StyledSelect
            value={sourceFieldRelation}
            MenuProps={MENU_PROPS}
            onChange={(e) => setSourceFieldRelation(e.target.value)}
            renderValue={renderBy(sourceRelationFields)}
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            {sourceRelationFields.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        {/* Relationship Entity */}
        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Relationship Entity
          </Typography>
          {/* Relationship Entity (value = entity_name, show label) */}
          <StyledSelect
            value={relationEntity}
            MenuProps={MENU_PROPS}
            onChange={handleRelationEntityChange}
            renderValue={renderBy(relationEntityOptions)}
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            {relationEntityOptions.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        {/* Relationship Field */}
        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Relationship Field
          </Typography>
          {/* Relationship Field (value = field_name, show label) */}
          <StyledSelect
            value={relationField}
            MenuProps={MENU_PROPS}
            // onChange={(e) => setRelationField(e.target.value)}
            onChange={handleRelationFieldChange}
            renderValue={renderBy(relationFields)}
          >
            <MenuItem value="">Select</MenuItem>
            {relationFields.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>

        {/* Value */}
        <FormControl fullWidth margin="normal">
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Value
          </Typography>
          {/* Value (if you want to pick a field as value; same mapping) */}
          <StyledSelect
            value={relationValue}
            MenuProps={MENU_PROPS}
            onChange={(e) => setRelationValue(e.target.value)}
            renderValue={renderBy(relationFields)}
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            {relationFields.map((opt) => (
              <MenuItem
                key={opt.value}
                value={opt.value}
                sx={{ minHeight: 'auto', py: 0.5, fontSize: 14 }}
              >
                {opt.label}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      </Box>
    </>
  );
}

RelationFunc.propTypes = {
  selectedFields: PropTypes.array,
  workflowId: PropTypes.string.isRequired,
  updatedConfig: PropTypes.object,
  sourceField: PropTypes.string,
  setSourceField: PropTypes.func,
  selectedEntities: PropTypes.array,
  relationEntity: PropTypes.string,
  setRelationEntity: PropTypes.func,
  relationField: PropTypes.string,
  setRelationField: PropTypes.func,
  relationValue: PropTypes.string,
  setRelationValue: PropTypes.func,
  relationFields: PropTypes.array,
  setRelationFields: PropTypes.func,
  sourceEntity: PropTypes.string,
  setSourceEntity: PropTypes.func,
  sourceFieldRelation: PropTypes.string,
  setSourceFieldRelation: PropTypes.func,
  relationEntityList: PropTypes.array,
  setRelationEntityList: PropTypes.func,
  selectedFieldName: PropTypes.array,
  setSelectedFieldName: PropTypes.func,
};

export default RelationFunc;
